import NProgress from 'nprogress'
import { getCode, getIframeLink, getCookie, delCookie, checkUserInfo,
  logout, getLink, findMenuLocation, getStorage } from "@/utils";
import commonApi from "@/api/common";

const beforeEach = async (to, from, next) => {
  NProgress.start();
  if (to.name == 'NOLOGIN') {
    next();
    return;
  }
  if (to.name == 'roleManage') {
    let _menu_code = to.query.menu_code;
    let _path = to.path;
    let _auth = await loginAuth(_menu_code, _path);
    if (_auth) {
      next();
    } else {
      next({ name: "NOLOGIN" });
    }
  } else {
    next()
  }
  // if (z && !isAuthenticated) next({ name: 'Login' })
  // else next()
}
export default beforeEach


async function loginAuth (_menu_code, _path) {
  let params = {
    "auth_key": _menu_code,
    "auth_type": 1,
    "router_path": _path, //  manage/index?type=lesson
  }
  return await commonApi.loginAuth(params).then(res => {
    if (res.code == 200) {
      return res.params.user_auth
    } else {
      return false;
    }
  }).catch(error => {
    console.error(error);
    return false;
  })
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js